import { startTimeout } from './timeout';

export interface RttData {
  rttMs: number | null;
  status: 'ok' | 'timeout';
}

export interface RttTrackingConfig {
  abortSignal: AbortSignal;
  loggingIntervalMs: number;
  onRttUpdate: (data: RttData) => void;
}

export interface RttTracking {
  recordPing(): void;
  recordPong(): void;
}

export function startRttTracking(config: RttTrackingConfig): RttTracking {
  let lastPingTime: number = 0;
  let lastRtt: number | null = null;

  function logRtt() {
    const rttMs = lastRtt;
    const status = rttMs !== null ? 'ok' : 'timeout';
    const rttData: RttData = {
      rttMs,
      status,
    };
    config.onRttUpdate(rttData);
    lastRtt = null;
  }

  const loggingInterval = startTimeout(() => {
    logRtt();
    loggingInterval.reset();
  }, config.loggingIntervalMs);

  config.abortSignal.addEventListener('abort', () => {
    loggingInterval.clear();
  });

  loggingInterval.reset();

  return {
    recordPing() {
      lastPingTime = performance.now();
      lastRtt = null;
    },
    recordPong() {
      if (lastPingTime === 0) return;
      const rttMs = Math.round(performance.now() - lastPingTime);
      lastRtt = rttMs;
    },
  };
}
